module.exports = __webpack_public_path__ + "static/media/apple-airpod.6a5f753a.jpeg";